<div class="p-3">
  <mat-accordion class="mt-1 faq-accordion mb-1">
    @for (size of sizes; track size; let i = $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'MySpace.CustomLogo.Titles.' + size | translate }}
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (loading[i]) {
            <mat-progress-bar class="mt-1" mode="indeterminate"></mat-progress-bar>
          }
          <div class="logo-displayer">
            <img [src]="imageLinks[i]" />
          </div>
          @if (showUploader[i]) {
            <div class="uploader mt-1">
              <label for="logo-upload" class="custom-file-upload">
                {{ 'Global.ChooseFile' | translate }}
              </label>
              <input id="logo-upload" type="file" (change)="onFileSelected($event, size, i)" />
              @if (wrongResolutionError[i]) {
                <div class="red-text mt-1">{{ 'Snackbar.WrongImageResolutionError' | translate }}</div>
              }
            </div>
          }
          <div class="logo-uploader">
            @if (showUploader[i]) {
              <button class="logo-button" mat-flat-button color="primary" [disabled]="wrongResolutionError[i] || !uploadedFiles[i] || loading[i]" (click)="uploadImage(size, i)">
                {{ 'Global.Save' | translate }}
              </button>
            }
            @if (!showUploader[i]) {
              <button class="logo-button" mat-flat-button color="primary" (click)="toggleUploader(i)">
                {{ 'Global.Edit' | translate }}
              </button>
            }
            @if (showUploader[i]) {
              <button mat-flat-button color="accent" (click)="toggleUploader(i)">
                {{ 'Global.Cancel' | translate }}
              </button>
            }
            @if (!isDefaultImage[i]) {
              <button class="logo-button" mat-flat-button color="warn" (click)="resetLogoImage(size, i)">
                {{ 'Global.Reset' | translate }}
              </button>
            }
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
